import { render, staticRenderFns } from "./AgendaWeekComponent.vue?vue&type=template&id=5b1f5527&scoped=true"
import script from "./AgendaWeekComponent.vue?vue&type=script&lang=js"
export * from "./AgendaWeekComponent.vue?vue&type=script&lang=js"
import style0 from "./AgendaWeekComponent.vue?vue&type=style&index=0&id=5b1f5527&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1f5527",
  null
  
)

export default component.exports